// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bet_a bho_bk bho_bl bho_bo","SwipeLeftToClose--animating":"bet_b"};